import { Create } from 'react-admin';

import { PrivateQuoteCreateEditForm } from './PrivateQuoteCreateEditForm';

export const PrivateQuoteCreate = () => (
  <Create redirect='list'>
    <PrivateQuoteCreateEditForm isEditMode />
  </Create>
);
